//import React, { useEffect, useState, useContext, useRef, useMemo } from 'react';
import React, { useEffect, useState, useContext, useRef, useMemo, useLayoutEffect, useCallback } from 'react';
import DataGrid from 'react-data-grid';
import { DeleteSessionSetup, AddSessionSetup, AddSetups, CurrentSessionHasBallSeries, AddSessionSetupsAndSeries, UpdateCurrentSession, GetCurrentSession, SetCurrentSession, SelectSessionSetup, CheckSessionSetup, CheckAllSessionSetup, UpdateSetup, CloneSetup, UpdateSetups, LoadSession, ImportPlateShotsFromSession } from '../isdlData/sessionData';
import './custom/rdgstyles.css';
// import 'react-data-grid/lib/styles.css';
import { getSetupColor, LMList } from '../utils/LMConstants';
import { Modal } from '@mui/material';
import NewSetup from './NewSetup';
import DeleteSetup from './DeleteSetup';
import { session_update } from '../mobile/mobileHandler';
import SetupListSelectHeader from './custom/SetupListSelectHeader';
import { AppContext, ViewOnlyContext, ThemeContext } from '../contexts/AppContext';
import SetupListContextMenu from './SetupsListContextMenu';
import RenameSetupModal from './RenameSetupModal';
import RenameGroupModal from './RenameGroupModal';
import CloneSetupModal from './CloneSetupModal';
import UpdateLetterSetupModal from './UpdateLetterSetupModal';
import ImportPlateShotsModal from './ImportPlateShotsModal';
import { useAppStateService } from '../contexts/AppState';

const cloneSetupsArray = (setups = []) => {
    if (!Array.isArray(setups)) {
        return [];
    }
    return setups.map(setup => ({ ...setup }));
};

function SetupsList({currentSession, setCurrentSetup, Disabled, Refresh, confirmationMode = false, onConfirm, onCancel, showCheckboxes = true, onShotsChanged}){   
    const [selectedSetup, setSelectedSetup] = useState(null);
    const [newSetupOpen, setNewSetupOpen] = useState(false);
    const [deleteSetupOpen, setDeleteSetupOpen] = useState(false);
    const [useSeries, SetUseSeries] = useState(false);
    const [isSessionTaskmanImported, setIsSessionTaskmanImported] = useState(false);
    const [isSetupTaskmanImported, setIsSetupTaskmanImported] = useState(false);
    const [rows, SetRows] = useState([]);
    const [draftSetups, setDraftSetups] = useState([]);
    const initialSetupsRef = useRef([]);
    const autoOpenedSessionId = useRef(null);
    const autoOpenedSessionKeys = useRef(new Set());

    const autoOpenStorageKey = 'setups_auto_opened_sessions';

    useEffect(() => {
        const storedSessions = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(autoOpenStorageKey) : null;
        if (storedSessions) {
            try {
                autoOpenedSessionKeys.current = new Set(JSON.parse(storedSessions));
            } catch (error) {
                autoOpenedSessionKeys.current = new Set();
            }
        }
    }, []);

    const rememberAutoOpenedSession = useCallback((sessionKey) => {
        autoOpenedSessionId.current = sessionKey;
        autoOpenedSessionKeys.current.add(sessionKey);

        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem(autoOpenStorageKey, JSON.stringify(Array.from(autoOpenedSessionKeys.current)));
        }
    }, []);

    const appState = useAppStateService();
    const { viewOnly } = useContext(ViewOnlyContext);
    const { theme, setAppTheme } = useContext(ThemeContext);
    const [currentTheme, setCurrentTheme] = useState(theme);

    const [contextMenu, showContextMenu] = useState(false);
    const [contextMenuData, setContextMenuData] = useState({ x: 0, y: 0 });

    let contextMenuReady = false;
    let touchTimeout = null; // To track the hold duration
    const holdDuration = 500; // Duration in ms to simulate a right-click
    const switchingSetups = useRef(false);
    const dataGridRef = useRef(null);
    const dataGridScrollLeftRef = useRef(0);

    const [renameSetupOpen, setRenameSetupOpen] = useState(false);
    const [renameGroupOpen, setRenameGroupOpen] = useState(false);
    const [cloneSetupOpen, setCloneSetupOpen] = useState(false);
    const [letterSetupOpen, setLetterSetupOpen] = useState(false);
    const [importPlateShotsOpen, setImportPlateShotsOpen] = useState(false);

    const getSetupDisplayStrings = (setup) => {
        if (!setup) {
            return { clubString: '', ballString: '' };
        }

        let clubString = '';
        if (setup.ClubName === 'Prototype') {
            if(setup.ClubDescription){
                clubString = setup.ClubDescription;
            }else{
                clubString = setup.ClubId;
            }
        } else if (setup.ClubName === 'Custom') {
            clubString = setup.ClubName + (setup.ClubId ? ` [${setup.ClubId}]` : '');
        } else {
            clubString = setup.ClubName;
        }

        let ballString = '';
        if(setup.BallName === 'Prototype'){
            if(setup.Id === 'Setup Series' || setup.Id.includes('Series ')){
                clubString = null;
                ballString = setup.Id;
            }else{
                ballString = setup.BallName + (!setup.BallPrototypeId ? '' : (`[${setup.BallPrototypeId}]`));
            }
        }else if(setup.BallName === 'Ball Series Testing'){
            if(setup.Id === 'Setup Series' || setup.Id.includes('Series ')){
                clubString = null;
                ballString = setup.Id;
            }else{
                ballString = setup.BallName + (!setup.BallPrototypeId ? '' : (`[${setup.BallPrototypeId}]`));
            }
        }else if(setup.BallName === 'None'){
            ballString = '';
        }else{
            ballString = setup.BallName;
        }

        return {
            clubString: clubString || '',
            ballString: ballString || '',
        };
    };


    useEffect(() => {
        const sessionHasTaskman = currentSession && currentSession.hasOwnProperty('TaskmanImported') && currentSession.TaskmanImported;
        setIsSessionTaskmanImported(!!sessionHasTaskman);

        if (confirmationMode) {
            const sessionSetups = currentSession && currentSession.SessionSetups ? cloneSetupsArray(currentSession.SessionSetups) : [];
            setDraftSetups(sessionSetups);
            initialSetupsRef.current = cloneSetupsArray(sessionSetups);

            if (sessionSetups.length > 0) {
                let curSetup = sessionSetups.find(setup => setup.IsSelected);
                if (curSetup === undefined) {//could happen!
                    curSetup = sessionSetups[0];
                }
                setSelectedSetup(curSetup);
                setIsSetupTaskmanImported(curSetup && curSetup.TaskmanImported ? curSetup.TaskmanImported : false);
            } else {
                setSelectedSetup(null);
                setIsSetupTaskmanImported(false);
            }

            UpdateRows(sessionSetups);
            showContextMenu(false);
        } else {
            if(currentSession && currentSession.SessionSetups && currentSession.SessionSetups.length > 0){
                let curSetup = currentSession.SessionSetups.find(setup => setup.IsSelected);
                if(curSetup === undefined){//could happen!
                    curSetup = currentSession.SessionSetups[0];
                }
                setSelectedSetup(curSetup);
                setIsSetupTaskmanImported(curSetup.hasOwnProperty('TaskmanImported') && curSetup.TaskmanImported ? curSetup.TaskmanImported : false);
            } else {
                setSelectedSetup(null);
                setIsSetupTaskmanImported(false);
            }

            setDraftSetups([]);
            initialSetupsRef.current = [];
            UpdateRows();
        }

        SetUseSeries(CurrentSessionHasBallSeries());
    },[currentSession, confirmationMode]);

    useEffect(() => {
        if (confirmationMode) {
            return;
        }

        const hasSession = !!currentSession;
        const hasSetups = currentSession?.SessionSetups && currentSession.SessionSetups.length > 0;
        const isTaskmanImported = currentSession?.TaskmanImported;
        const currentSessionKey = currentSession?.id ?? currentSession?.TaskID ?? currentSession?.Description ?? '__anonymous_session';

        const hasAutoOpenedForSession = autoOpenedSessionId.current === currentSessionKey || autoOpenedSessionKeys.current.has(currentSessionKey);

        if (hasSession && !hasSetups && !isTaskmanImported && !hasAutoOpenedForSession) {
            setNewSetupOpen(true);
            rememberAutoOpenedSession(currentSessionKey);
        }
    }, [confirmationMode, currentSession, rememberAutoOpenedSession]);

    useEffect(() => {
        if (confirmationMode) {
            UpdateRows(draftSetups);
        } else {
            UpdateRows();
        }
    },[Disabled, confirmationMode, draftSetups]);

    useEffect(() => {
    setCurrentTheme(theme);
    }, [theme]);
    const getDataGridElement = () => {
        const element = dataGridRef.current;
        if (!element) {
            return null;
        }

        if (element.element) {
            return element.element;
        }

        return element;
    };

    useLayoutEffect(() => {
        const gridElement = getDataGridElement();
        if (!gridElement) {
            return undefined;
        }

        const viewport = gridElement.querySelector('.rdg-viewport') || gridElement;

        const handleScroll = () => {
            dataGridScrollLeftRef.current = viewport.scrollLeft;
        };

        viewport.scrollLeft = dataGridScrollLeftRef.current;
        viewport.addEventListener('scroll', handleScroll);

        return () => {
            viewport.removeEventListener('scroll', handleScroll);
        };
    }, [rows]);

    useLayoutEffect(() => {
        if (!selectedSetup?.Id) {
            return undefined;
        }

        const gridElement = getDataGridElement();
        if (!gridElement) {
            return undefined;
        }

        const focusSelectedRow = () => {
            const selectedCell = gridElement.querySelector('.row-selected [role="gridcell"]');
            if (selectedCell && typeof selectedCell.focus === 'function') {
                selectedCell.focus();
            }
        };

        const frameId = window.requestAnimationFrame(focusSelectedRow);
        return () => window.cancelAnimationFrame(frameId);
    }, [selectedSetup?.Id, rows]);

    useEffect(() => {
        dataGridScrollLeftRef.current = 0;
        const gridElement = getDataGridElement();
        if (!gridElement) {
            return;
        }

        const viewport = gridElement.querySelector('.rdg-viewport') || gridElement;
        if (viewport) {
            viewport.scrollLeft = 0;
        }
    }, [currentSession]);

    const CustomCheckedCellRenderer = ({ column, row }) => { //This HAS to be before the const columns @_@
        let value = row[column.key];
        const style = {
            width: '25px',
            height: '25px',
            transform: 'translate(-7px, 2px)',
            zIndex: '100'
        };
    
        return <div>

            <input type="checkbox" style={style} checked={value} onClick={e => e.stopPropagation()} onChange={handleCheckCellClick(row, value)} disabled={Disabled}/>

        </div>;
    };

    const checkboxHeaderText = confirmationMode ? 'Show Shots' : '';
    const checkboxColumnBaseWidth = 35;
    const estimatedHeaderTextWidth = checkboxHeaderText.length * 8;
    const checkboxColumnWidth = showCheckboxes ? Math.max(checkboxColumnBaseWidth, estimatedHeaderTextWidth + 24) : checkboxColumnBaseWidth;
    const checkboxColumn = { key: 'IsChecked', name: '', width: checkboxColumnWidth, minWidth: checkboxColumnWidth, maxWidth: checkboxColumnWidth, resizable: false,
        renderHeaderCell() {
            if (confirmationMode) {
                return <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold'}}>Show Shots</div>;
            }
            return <SetupListSelectHeader headerClicked={handleCheckHeaderClick} disabled={Disabled} />;
          },
        renderCell(props) {
            return (
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}>
                    {CustomCheckedCellRenderer(props)}
                </div>
            );
        },
    };

    const estimatedNameColumnWidth = useMemo(() => {
        const characterWidth = 7;
        const padding = 32;

        let maxLength = confirmationMode ? 'Highlighted Row is Active'.length : 'Name'.length;

        (rows || []).forEach(row => {
            const { clubString, ballString } = getSetupDisplayStrings(row);
            const length = Math.max(clubString.length, ballString.length);
            if (length > maxLength) {
                maxLength = length;
            }
        });

        const computedWidth = (maxLength * characterWidth) + padding;
        const minWidth = 100;
        const maxWidth = 360;
        return Math.min(maxWidth, Math.max(minWidth, computedWidth));
    }, [rows, confirmationMode]);

    const displayNameColumnWidth = estimatedNameColumnWidth;

    const displayNameColumnTitle = confirmationMode ? 'Highlighted Row is Active' : 'Name';
    const baseColumns = [
        { key: 'DrawingColor', name: '', width: 35, minWidth: 35, resizable: false,
        renderCell(row){
            const setup = row.row;
            const rowIdx = row.rowIdx;
            const color = getSetupColor(setup, rowIdx);
            return(
                <div style={{background:color.bg, color:color.fg, height: "100%" , width: "calc(100% + 16px)", transform: "translateX(-8px)", display:'flex', justifyContent:'center', alignItems:'center', fontWeight:'bold', fontSize:'18px'}}>
                    {setup.LetterId ? setup.LetterId : ""}
                </div>
            );
        }
         },
        { key: 'DisplayName', name: displayNameColumnTitle, resizable: false, minWidth: 100,
        renderCell(row){

            const setup = row.row;
            const { clubString, ballString } = getSetupDisplayStrings(setup);

            return(
                <>
                {(clubString || ballString) && (
                    <div className={clubString && ballString ? 'setup-row-double' : 'setup-row'}>
                        {clubString && <div style={{width:'100%', height:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>{clubString}</div>}
                        {ballString && <div style={{width:'100%', height:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>{ballString}</div>}
                    </div>
                )}
                </>
                
            );
            }
         },
    ];

    const columns = showCheckboxes ? [checkboxColumn, ...baseColumns] : baseColumns;
    const totalCheckedShots = useMemo(() => {
        if (!rows || rows.length === 0) {
            return 0;
        }

        return rows.reduce((setupTotal, setup) => {
            if (!setup || !Array.isArray(setup.Shots)) {
                return setupTotal;
            }

            const checkedCount = setup.Shots.reduce((shotTotal, shot) => {
                return shotTotal + (shot && shot.IsChecked ? 1 : 0);
            }, 0);

            return setupTotal + checkedCount;
        }, 0);
    }, [rows]);
    const handleShotsChanged = useCallback(() => {
        const sourceSetups = confirmationMode
            ? cloneSetupsArray(draftSetups)
            : cloneSetupsArray(currentSession && Array.isArray(currentSession.SessionSetups) ? currentSession.SessionSetups : []);

        SetRows(sourceSetups);
    }, [confirmationMode, currentSession, draftSetups]);

    useEffect(() => {
        if (typeof onShotsChanged === 'function') {
            onShotsChanged(handleShotsChanged);
        }
    }, [handleShotsChanged, onShotsChanged]);
    function UpdateRows(sourceSetups){
        const rowsSource = sourceSetups ? sourceSetups : (currentSession && currentSession.SessionSetups ? currentSession.SessionSetups : []);
        SetRows(rowsSource ? rowsSource.map(setup => ({
            ...setup,
            // selected: selectedSetup?.id === setup.id
        })) : []);
    };

    const handleRowClick = async (rowIdx) => {

        if(Disabled){
            return;
        }

        await selectSessionSetup(rowIdx.row);
        
        if (!confirmationMode) {
            if (contextMenuReady) {
                if(contextMenu){
                    showContextMenu(false);
                    contextMenuReady = false;
                }else{
                    showContextMenu(true);
                    contextMenuReady = false;
                }
            } else {
                showContextMenu(false);
            }
        } else {
            showContextMenu(false);
        }

        // rows = currentSession.SessionSetups.map(setup => ({
        //     ...setup,
        //     // selected: selectedSetup?.id === setup.id
        //     }));
    };

    async function selectSessionSetup(setup) {

        let localSession = currentSession;

        if (confirmationMode) {
            const updatedSetups = (draftSetups || []).map(item => ({
                ...item,
                IsSelected: item.Id === setup.Id
            }));
            setDraftSetups(updatedSetups);
            const newSelected = updatedSetups.find(item => item.Id === setup.Id) || null;
            setSelectedSetup(newSelected);
            setIsSetupTaskmanImported(newSelected && newSelected.TaskmanImported ? newSelected.TaskmanImported : false);
            UpdateRows(updatedSetups);
            return;
        }

        while (switchingSetups.current) {
            await new Promise(resolve => setTimeout(resolve, 1));
        }

        switchingSetups.current = true;

        for (let i = 0; i < localSession.SessionSetups.length; i++) {
            localSession.SessionSetups[i].IsSelected = false;
        }

        let setupRow = localSession.SessionSetups.find(s => s.Id === setup.Id);
        setupRow.IsSelected = true;

        const updateDb = !viewOnly;

        await SelectSessionSetup(localSession, setupRow, false);

        await CheckAllSessionSetup(false, false);
        await CheckSessionSetup(localSession, setupRow, true, updateDb);

        const refreshedSetup = localSession.SessionSetups.find(s => s.Id === setup.Id) || setupRow;
        setIsSetupTaskmanImported(refreshedSetup.TaskmanImported ? refreshedSetup.TaskmanImported : false);
        setSelectedSetup(refreshedSetup);

        if (setCurrentSetup) {
            setCurrentSetup(refreshedSetup.Id);
        }

        session_update(localSession.id, refreshedSetup.Id, viewOnly);
        UpdateRows();
        switchingSetups.current = false;
    }

    const newSetupClick = async () => {
        if (confirmationMode) {
            return;
        }

        setNewSetupOpen(true);
    };

    const handleNewSetup = async (setup) => {
        await AddSessionSetup(setup);
        const currentSession = GetCurrentSession();
        setSelectedSetup(currentSession.SessionSetups.find(s => s.Id == setup.Id));

        // for(let i = 0; i < currentSession.SessionSetups.length; i++){

        //     if(currentSession.SessionSetups[i].Id === setup.Id)
        //         currentSession.SessionSetups[i].IsSelected = true;
        //     else
        //         currentSession.SessionSetups[i].IsSelected = false;
        // }

        setCurrentSetup(setup.Id);

            session_update(currentSession.id, setup.Id, viewOnly);

        SetUseSeries(CurrentSessionHasBallSeries());
        UpdateRows();
    };

    const handleNewMultipleSetups = async (setups, series) => {
        await AddSessionSetupsAndSeries(setups,series);
        const firstSetup = currentSession.SessionSetups[0];
        setSelectedSetup(firstSetup);

        // for(let i = 0; i < currentSession.SessionSetups.length; i++){

        //     if(currentSession.SessionSetups[i].Id === firstSetup.Id)
        //         currentSession.SessionSetups[i].IsSelected = true;
        //     else
        //         currentSession.SessionSetups[i].IsSelected = false;
        // }

        setCurrentSetup(firstSetup.Id);
        session_update(currentSession.id, firstSetup.Id, viewOnly);

        SetUseSeries(CurrentSessionHasBallSeries());
        UpdateRows();
    };

    const deleteSetupClick = async () => {
        if (confirmationMode) {
            return;
        }

        setDeleteSetupOpen(true)
    };

    const handleDeleteSetup = async () =>{
        let deletedSetupId = "";
        if(currentSession.SessionSetups.length === 1){
            deletedSetupId = selectedSetup.Id;
        }

        //delete setup logic
        await DeleteSessionSetup(selectedSetup.Id);
        
        if(currentSession.SessionSetups.length > 1){
            const newCurrentSetup = currentSession.SessionSetups[0];

                session_update(currentSession.id, newCurrentSetup.Id, viewOnly);
            setSelectedSetup(currentSession.SessionSetups.find(s => s.Id == newCurrentSetup.Id));
            setCurrentSetup(newCurrentSetup.Id);
        }else if(currentSession.SessionSetups.length === 0){
                session_update(currentSession.id, "no_setup");

            setSelectedSetup(null);
            setCurrentSetup(null);
        }
        
        UpdateRows();
    };

    const handleCheckHeaderClick = async (e) => {
        let checked = e.target.checked;

        if (confirmationMode) {
            const updated = (draftSetups || []).map(setup => ({ ...setup, IsChecked: checked }));
            setDraftSetups(updated);
            UpdateRows(updated);
            return;
        }

        await CheckAllSessionSetup(checked, !viewOnly);

        UpdateRows();

        if(selectedSetup){
            session_update(currentSession.id, selectedSetup.Id, viewOnly);
        }
        else{
            session_update(currentSession.id, );
        }
    };

    const handleCheckCellClick = (row, checked) => (e) => {
        handleCheckCell(e,row);
         setCurrentSetup(row.Id);
    };

    const handleCheckCell = async (e,row) =>{
        let checked = e.target.checked;

        if (confirmationMode) {
            const updated = (draftSetups || []).map(item => item.Id === row.Id ? { ...item, IsChecked: checked } : { ...item });
            setDraftSetups(updated);
            UpdateRows(updated);
            return;
        }

        let setupRow = currentSession.SessionSetups.find(s => s.Id === row.Id);
        

        await CheckSessionSetup(currentSession, setupRow, checked, !viewOnly);

        // SetCurrentSession(currentSession);
        UpdateRows();
        // setCurrentSetup(setupRow.Id);
        // await UpdateCurrentSession();

            // session_update(currentSession.id, setupRow.Id, viewOnly);
    };

    const handleButtonDisabled = (buttonType) => {
        if(confirmationMode){
            return true;
        }

        if(useSeries){
            return true;
        }

        if(viewOnly){
            return true;
        }

        if(Disabled){
            return true;
        }

        //if auto generated setups from task id, return true
        if(buttonType === "ADD"){
            return false;
        }else if(buttonType === "DELETE"){
            if(isSetupTaskmanImported){
                return true;
            }
        }

        return false;
    }

    const handleRightClicks = e => {
        e.preventDefault();
        if (confirmationMode) return;
        const targetElement = e.target;
        if (targetElement && typeof targetElement.click === 'function') {
          setContextMenuData({ x: e.clientX, y: e.clientY });
          contextMenuReady = true;
          targetElement.click();
        }
      };
    
    const handleTouchStart = e => {
    if (confirmationMode) return;
    const targetElement = e.target;
    touchTimeout = setTimeout(() => {
        if (targetElement && typeof targetElement.click === 'function') {
        setContextMenuData({ x: e.touches[0].clientX, y: e.touches[0].clientY });
        contextMenuReady = true;
        targetElement.click();
        }
    }, holdDuration);
    };

    const handleTouchEnd = () => {
    if (touchTimeout) {
        clearTimeout(touchTimeout);
        touchTimeout = null;
    }
    };

    const handleContextItemSelected = (option) => {
        showContextMenu(false);
        if (confirmationMode) {
            return;
        }
        switch (option) {
            case 'CLONE':
                setCloneSetupOpen(true);
            break;
            case 'RENAME':
                setRenameSetupOpen(true);
            break;
            case 'MOVEUP':
                handleSetupMove('up');
                break;
            case 'MOVEDOWN':
                handleSetupMove('down');
                break;
            case 'CHANGELETTER':
                setLetterSetupOpen(true);
                break;
            case 'CHANGEGROUPNUM':
                setRenameGroupOpen(true)
                //setGroupNumber(true);
                break;
            case 'IMPORTPLATESHOTS':
                setImportPlateShotsOpen(true);
                break;
            default:
            break;
        }
    };

    const handleRenameSetup = async (result, value) => {
        if(!result){
            setRenameSetupOpen(false);
        }else{
            let newSetup = selectedSetup;
            let updates = {};
            newSetup.ClubDescription = value.clubDescription;
            updates.ClubDescription = value.clubDescription;
            if (newSetup?.TestParameters?.RobotFaceMap && value?.robotFaceMap) {
                const updatedRobotFaceMap = {
                    ...newSetup.TestParameters.RobotFaceMap,
                    Name: value.clubDescription,
                    y: value.robotFaceMap.y,
                    z: value.robotFaceMap.z
                };

                newSetup.TestParameters = {
                    ...(newSetup.TestParameters || {}),
                    RobotFaceMap: updatedRobotFaceMap
                };
                updates.TestParameters = newSetup.TestParameters;
            }
            if(!newSetup.TaskmanImported && value.hasOwnProperty('clubId')){
                newSetup.ClubId = value.clubId;
                updates.ClubId = value.clubId;
            }

            await UpdateSetup(newSetup, updates);
            setRenameSetupOpen(false);
            UpdateRows();

            Refresh(); 
            
        }
    }
    const handleRenameGroupSetup = async (result, value) => {
        if(!result){
            setRenameGroupOpen(false);
        }else{
            const currentSessionData = GetCurrentSession();
            if (!currentSessionData) {
                setRenameGroupOpen(false);
                return;
            }

            const updatedSeries = Array.isArray(value?.ballSeries)
                ? value.ballSeries.map(item => (item === null || item === undefined ? '' : String(item)))
                : [];
            const seriesItems = Array.isArray(value?.seriesItems)
                ? value.seriesItems.map(item => ({
                    name: item?.name === null || item?.name === undefined ? '' : String(item.name),
                    originalName: item?.originalName === null || item?.originalName === undefined ? null : String(item.originalName)
                }))
                : [];

            const groupRenameMap = seriesItems.reduce((acc, item) => {
                if (item.originalName !== null && item.originalName !== item.name) {
                    acc[item.originalName] = item.name;
                }
                return acc;
            }, {});

            const updatedSetups = Array.isArray(currentSessionData.SessionSetups)
                ? currentSessionData.SessionSetups.map(setup => {
                    if (!Array.isArray(setup.Shots)) {
                        return setup;
                    }
                    const updatedShots = setup.Shots.map(shot => {
                        if (shot.Group === null || shot.Group === undefined) {
                            return shot;
                        }
                        const groupKey = String(shot.Group);
                        if (!Object.prototype.hasOwnProperty.call(groupRenameMap, groupKey)) {
                            return shot;
                        }
                        return { ...shot, Group: groupRenameMap[groupKey] };
                    });
                    return { ...setup, Shots: updatedShots };
                })
                : currentSessionData.SessionSetups;

            const updatedSession = { ...currentSessionData, BallSeries: updatedSeries, SessionSetups: updatedSetups };
            SetCurrentSession(updatedSession);
            await UpdateCurrentSession();
            setRenameGroupOpen(false);
            UpdateRows();
            Refresh();
        }
    }
    const handleCloneSetup = async (result) => {
        if(!result){
            setCloneSetupOpen(false);
        }else{

            let newData = {ClubDescription: selectedSetup.ClubDescription ? selectedSetup.ClubDescription + " (COPY)" : "COPY"}

            let clonedSetup = await CloneSetup(selectedSetup,newData)

            await selectSessionSetup(clonedSetup);

            setCloneSetupOpen(false);
            UpdateRows();

            Refresh();
        }
    }
    
    const handleSetupMove = async (direction) => {
        let oldIdx = 0;
        let newIdx = 0;

        switch(direction){
            case 'up':
                oldIdx = currentSession.SessionSetups.findIndex(s => s.Id === selectedSetup.Id);
                newIdx = oldIdx - 1;
                break;
            case 'down':
                oldIdx = currentSession.SessionSetups.findIndex(s => s.Id === selectedSetup.Id);
                newIdx = oldIdx + 1;
                break;
        }

        const copy = [...currentSession.SessionSetups];
        [copy[oldIdx], copy[newIdx]] = [copy[newIdx], copy[oldIdx]];
        const newSetupList = copy.map((item) => ({ ...item}));

        await UpdateSetups(newSetupList);

        Refresh();
    }

    const handleUpdateLetterResult = async (result, value) => {
        if(!result){
            setLetterSetupOpen(false);
        }else{
            let newSetup = selectedSetup;
            newSetup.LetterId = value;

            await UpdateSetup(newSetup, {LetterId:value});
            UpdateRows();
            setLetterSetupOpen(false);

        Refresh();
        }
    }

    const handleImportPlateShots = async (result) => {
        if (!result?.valid) {
            setImportPlateShotsOpen(false);
            return;
        }

        try {
            await ImportPlateShotsFromSession(result.sessionId, {
                sourceSetupId: result.sourceSetupId,
                targetSetupId: selectedSetup?.Id,
                replaceExisting: !!result.replaceExisting
            });

            const updatedSession = GetCurrentSession();
            const updatedPlateSetup = updatedSession?.SessionSetups?.find((setup) => setup?.Id === selectedSetup?.Id)
                || updatedSession?.SessionSetups?.find((setup) => Array.isArray(setup?.Shots) && setup.Id === selectedSetup?.Id)
                || selectedSetup;

            if (updatedPlateSetup) {
                setSelectedSetup(updatedPlateSetup);
                if (setCurrentSetup) {
                    setCurrentSetup(updatedPlateSetup.Id);
                }
                session_update(updatedSession.id, updatedPlateSetup.Id, viewOnly);
            }

            UpdateRows(updatedSession?.SessionSetups);
            setImportPlateShotsOpen(false);

            if (Refresh) {
                Refresh();
            }
        } catch (error) {
            console.error('Import Plate shots failed:', error);
            const event = new CustomEvent('upsertSessionError', {
                detail: {
                    message: 'Import Plate shots failed.\n' + (error?.message || 'Unknown error')
                }
            });
            window.dispatchEvent(event);
            setImportPlateShotsOpen(false);
        }
    }

    const handleConfirmClick = async () => {
        if (!confirmationMode) {
            return;
        }

        if (!currentSession) {
            if (onConfirm) {
                onConfirm({ selectedSetupId: null, hasChanges: false });
            }
            return;
        }

        const draft = draftSetups || [];
        const sessionSetups = currentSession.SessionSetups ? currentSession.SessionSetups : [];

        const sessionMap = new Map(sessionSetups.map(setup => [setup.Id, setup]));
        const checkboxChanges = [];

        for (const setup of draft) {
            const existing = sessionMap.get(setup.Id);
            if (!existing) {
                continue;
            }

            if (!!existing.IsChecked !== !!setup.IsChecked) {
                checkboxChanges.push({ setup: existing, isChecked: !!setup.IsChecked });
            }
        }

        for (const change of checkboxChanges) {
            await CheckSessionSetup(currentSession, change.setup, change.isChecked, !viewOnly);
        }

        const draftSelected = draft.find(s => s.IsSelected);
        const currentSelected = sessionSetups.find(s => s.IsSelected);
        const draftSelectedId = draftSelected ? draftSelected.Id : null;
        const currentSelectedId = currentSelected ? currentSelected.Id : null;
        const selectionChanged = !!draftSelectedId && draftSelectedId !== currentSelectedId;

        if (selectionChanged) {
            const targetSetup = sessionMap.get(draftSelectedId);
            if (targetSetup) {
                await SelectSessionSetup(currentSession, targetSetup);
                setSelectedSetup(targetSetup);
                setIsSetupTaskmanImported(targetSetup.TaskmanImported ? targetSetup.TaskmanImported : false);
                if (setCurrentSetup) {
                    setCurrentSetup(targetSetup.Id);
                }
                session_update(currentSession.id, targetSetup.Id, viewOnly);
            }
        }

        const hasChanges = checkboxChanges.length > 0 || selectionChanged;

        if (hasChanges && Refresh) {
            await Refresh();
        }

        initialSetupsRef.current = cloneSetupsArray(draft);
        setDraftSetups(cloneSetupsArray(draft));

        if (onConfirm) {
            onConfirm({
                selectedSetupId: draftSelectedId,
                hasChanges
            });
        }
    };

    const handleCancelClick = () => {
        if (!confirmationMode) {
            return;
        }

        const resetSetups = cloneSetupsArray(initialSetupsRef.current);
        setDraftSetups(resetSetups);
        const resetSelected = resetSetups.find(setup => setup.IsSelected) || null;
        setSelectedSetup(resetSelected);
        setIsSetupTaskmanImported(resetSelected && resetSelected.TaskmanImported ? resetSelected.TaskmanImported : false);
        UpdateRows(resetSetups);

        if (onCancel) {
            onCancel();
        }
    };

    return(
        <div style={{width:'100%', height:'max-content'}} 
            onContextMenu={handleRightClicks}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            >
            <h2 style={{textAlign:'center',marginBottom: '0.25rem'}}>{confirmationMode ? 'VISIBLE SETUPS' : 'SETUPS'}</h2>
            <h4 style={{textAlign:'center', color:'#aaa', opacity:0.7, marginTop: '0',marginBottom: '0.25rem' }}>({totalCheckedShots}) total shots selected</h4>
            <div style={{width:'calc(100% - 10px)', height:'auto'}}>
                <DataGrid
                    ref={dataGridRef}
                    className={`${currentTheme == "dark" ? "rdg-dark" : "rdg-light"} setups-grid`}
                    style={{ height: "max-content", contain: "none", margin: "0px 5px 0px 5px", width: '100%' }}
                    columns={columns}
                    rows={rows}
                    headerRowHeight={showCheckboxes ? undefined : 0}
                    onCellClick={handleRowClick}
                    rowClass={(row) => row.IsSelected ? 'row-selected' : 'row-unselected'}
                />
            </div>
            <div className="buttonContainer" style={{backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--background-secondary')}}>
                {confirmationMode ? (
                    <>
                        <button className="button" style={{width:"100px"}} onClick={handleConfirmClick}>OK</button>
                        <button className="button" style={{width:"100px"}} onClick={handleCancelClick}>Cancel</button>
                    </>
                ) : (
                    <>
                        <button className="button" style={{width:"100px"}} onClick={newSetupClick} disabled={handleButtonDisabled("ADD")}>Add New</button>
                        <button className="button" style={{width:"100px"}} onClick={deleteSetupClick} disabled={handleButtonDisabled("DELETE")}>Delete</button>
                    </>
                )}
            </div>

            <Modal
                open={newSetupOpen}>
                    <NewSetup setModalState={setNewSetupOpen} addNewSetup={handleNewSetup} addMultipleNewSetups={handleNewMultipleSetups}/>
            </Modal>
            <Modal
                open={deleteSetupOpen}>
                    <DeleteSetup selectedSetup={selectedSetup} setDeleteModalState={setDeleteSetupOpen} deleteSetup={handleDeleteSetup}/>
            </Modal>
            <Modal
                open={renameSetupOpen}>
                <RenameSetupModal CurrentSetup={selectedSetup} finalizeRenameResult={handleRenameSetup}/>
            </Modal>
            <Modal
                open={renameGroupOpen}>
                <RenameGroupModal ballSeries={currentSession?.BallSeries ?? []} finalizeRenameResult={handleRenameGroupSetup}/>
            </Modal>
            <Modal
                open={cloneSetupOpen}>
                <CloneSetupModal CurrentSetup={selectedSetup} finalizeCloneResult={handleCloneSetup}/>
            </Modal>
            <Modal
                open={letterSetupOpen}>
                <UpdateLetterSetupModal CurrentSession={currentSession} CurrentSetup={selectedSetup} updateLetterResult={handleUpdateLetterResult}/>
            </Modal>
            <Modal
                open={importPlateShotsOpen}>
                <ImportPlateShotsModal currentSession={currentSession} currentSetup={selectedSetup} onComplete={handleImportPlateShots} theme={currentTheme} />
            </Modal>
            {contextMenu && (
                <SetupListContextMenu
                ContextLocation={contextMenuData}
                CurrentSetup={selectedSetup}
                CurrentSession={currentSession}
                HandleSetupContext={handleContextItemSelected}
                />
            )}
        </div>
    );
}
export default SetupsList;
